
import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const Monitor: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
      <path d="M5.08 14V12.8333H6.8V10.8889H1.2C0.88 10.8889 0.6 10.7722 0.36 10.5389C0.12 10.3056 0 10.0333 0 9.72222V1.16667C0 0.855556 0.12 0.583333 0.36 0.35C0.6 0.116667 0.88 0 1.2 0H14.8C15.12 0 15.4 0.116667 15.64 0.35C15.88 0.583333 16 0.855556 16 1.16667V9.72222C16 10.0333 15.88 10.3056 15.64 10.5389C15.4 10.7722 15.12 10.8889 14.8 10.8889H9.2V12.8333H10.92V14H5.08ZM1.2 9.72222H14.8V1.16667H1.2V9.72222Z" fill="white" fillOpacity="0.8" />
    </svg>
  </SvgWrapper>
);

